import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import backgroundColor from '@material-ui/core/colors/indigo';

import TaskTable from './TaskTable';

import {
  startEditBid,
} from '../../../../store/actions/bids';

const styles = theme => ({
  root: {
    backgroundColor: backgroundColor[200],
  },
  column: {
    flexGrow: 1,
  },
  rightAlign: {
    textAlign: 'right',
  },
  details: {
    padding: '0px',
  },
  white: {
    color: '#fff',
  }
});

//TODO: refactor so not using type prop to calculate number of items
const JobTaskItems = ({ classes, type, bids, bidTask, preview, startEditBid }) => {
  let numItems;
  switch (type.toLowerCase()) {
    case "labor":
      numItems = bidTask.labor.length;
      break;
    case "materials":
      numItems = bidTask.materials.length;
      break;
    default:
      numItems = 0;
  }

  return(
    <ExpansionPanel className={classes.root}>
      <ExpansionPanelSummary
        className={classes.summary}
        expandIcon={<ExpandMoreIcon className={classes.white}/>
      }>
        <div className={classes.column}>
          <Typography
            variant="subheading"
            className={classes.white}
            >
              {type}
            </Typography>
        </div>
        <div className={classes.column}>
          <Typography
            variant="subheading"
            className={classNames(classes.rightAlign, classes.white)}
          >
            {numItems} Items
          </Typography>
        </div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.details}>
        <TaskTable preview={preview} type={type} bidTask={bidTask} />
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

const mapStateToProps = (state) => ({
  bid: state.bidsState.find( bid => bid.id === state.adminState.bid.id ),
});

const mapDispatchToProps = (dispatch) => ({
  startEditBid: (bidId, bid) => dispatch(startEditBid(bidId, bid)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(JobTaskItems);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/JobTaskItems.jsx